// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://planeed-dev.wunu.dev',
  websiteUrl: 'https://planeed-web.wunu.dev',
  name: 'dev',
  mapboxAccessTokenWeb: 'pk.eyJ1IjoiZGFib2NrIiwiYSI6ImNtaGFreHBiMDBucTMybHJ6dDdrZnI1Y2EifQ.SrDwtRBo37Yf9rGN4QycTg',
  mapboxAccessTokenMobile: 'pk.eyJ1IjoiZGFib2NrIiwiYSI6ImNtZXdnOXgwbzBubjUya3IyNTA2Zmo1MzEifQ.EzXG4CVHDaX6_TBNntFYzg',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
